module.exports = __webpack_public_path__ + "media/images/men-talking-background-307add337c8994bdfa51443d81ad7a69.png";